module.exports = "<div class=one-page-auth> <div style=\"background-image:url(<%=thumbnailUrl%>)\" class=page-auth-thumb></div> <div class=page-auth-msg><%=authorizationMessage%></div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/templates/page-authorization-template.html
// module id = 68
// module chunks = 0